import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GlossaryListPage } from '@/features/data/catalog/glossary-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Glossaire métier du locataire (`GET /glossary/terms?search`) ; la recherche vit dans l'URL. */
export const Route = createFileRoute('/$tenant/glossary/')({
  validateSearch: (search: Record<string, unknown>): { search?: string } => {
    const value = typeof search['search'] === 'string' ? search['search'].trim() : '';
    return value ? { search: value } : {};
  },
  component: GlossaryRoute,
});

function GlossaryRoute() {
  const { tenant } = Route.useParams();
  const { search = '' } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="glossary" crumbs={[{ label: t('nav.items.glossary') }]}>
      <GlossaryListPage
        tenantId={tenant}
        search={search}
        onSearch={(next) => void navigate({ search: next ? { search: next } : {}, replace: true })}
      />
    </ConsoleShell>
  );
}
